import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/aviso-para-presentar-declaracion-anual-isr-del-empleado/';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getOtros = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET PrestacionNombramiento
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getOtro = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Otro =
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postOtro = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Otro =
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchOtro = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Otro =
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteOtro = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
